export default "__VITE_ASSET__BKSdrepl__"